import { AppCountryConfig } from './../interface/app-config';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Http } from '@angular/http';
import { JsonSchemaFormService } from 'angular4-json-schema-form-updated';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import { Member } from '../../shared/interface/member.interface';
import { ConfigurationService } from '../services/configuration.service';
import { DataShareService } from '../../shared/services/data.service';
import { CommonService } from '../../shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslateKey } from '../../common/pipes/translate-key.pipe';
import { SchemaProperty } from '../enums/schema-property.enum';
import { StatusCodes } from '../enums/status-code.enum';
import { ResponseStatus } from '../constants/response-status-constants';
import { MemberType } from '../common/constants';
import { Translations } from '../constants/translations.constants';
import { IbanValidation } from '../models/IbanValidation.model';
import { PersonalMessageService } from '../services/personal-schema-form.service';
import { AppConfigService } from '../services/app-config.service';
import { BonusInfo } from '../interface/bonus-info.interface';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'custom-input-widget',
    template: `
    <!-- [class]="options?.htmlClass || ''"-->
    <div [class.floatLabelContainer]="true">
      <label *ngIf="options?.title"
        [attr.for]="'control' + layoutNode?._id"
        [class]="options?.labelHtmlClass || ''"
        [style.display]="options?.notitle ? 'none' : ''"
        [innerHTML]="options?.title"></label>
      <!-- email input tag is to autofill the content default -->
      <input type="email" name="email_autofill" value="" style="display:none;" />
      <input float-label
        [formControl]="formControl"
        [attr.aria-describedby]="'control' + layoutNode?._id + 'Status'"
        [attr.list]="'control' + layoutNode?._id + 'Autocomplete'"
        [attr.maxlength]="options?.maxLength"
        [attr.minlength]="options?.minLength"
        [attr.pattern]="options?.pattern"
        [attr.placeholder]="options?.placeholder"
        [attr.required]="options?.required"
        [class]="options?.fieldHtmlClass || ''"
        [disabled]="controlDisabled"
        [id]="'control' + layoutNode?._id"
        [name]="controlName"
        [readonly]="options?.readonly ? 'readonly' : null"
        [type]="layoutNode?.type"
        [value]="controlValue"
        [mask]="options?.maskFormat"
        (input)="updateValue($event);focusInputOnChange();validateInputValue($event)" (keypress)="onChange()" (keydown)="onChange()"
        (keyup)="removeError();onChange()" (paste)="onChange()" (blur)=validateInputValue($event)>
        <datalist *ngIf="options?.typeahead?.source"
          [id]="'control' + layoutNode?._id + 'Autocomplete'">
          <option *ngFor="let word of options?.typeahead?.source" [value]="word">
        </datalist>
        <!-- Email verification spinner block start -->
        <span *ngIf="layoutNode?.name==='email' && isShowLoader" tabindex="0" class="personal-info--email-info">
        <i class="fa fa-spinner"></i></span>
        <!-- Email verification spinner block end -->
        <!-- Government Id verification spinner block start -->
        <span *ngIf="(layoutNode?.name==='governmentId' || layoutNode?.name=== 'accountNumber') && isShowGovernmentIdLoader" tabindex="0" class="personal-info--email-info">
        <i class="fa fa-spinner"></i></span>
        <!-- Government Id verification spinner block end -->
    </div>
    <span *ngIf="!formControl.hasError('required') && emailError && (!isShowLoader)"
    [class]="'error custom-error'">{{'schemaform.There is an existing account registered with this email-id in our system, A unique value is required to proceed'
    |translate |translateKey }}</span>
    <span *ngIf="!formControl.hasError('required') && customMessage && (!isShowLoader || !isShowGovernmentIdLoader)"
    [class]="'error custom-error'">{{customMessage}}</span>`,
})
export class CustomInputComponent implements OnInit {
    formControl: AbstractControl;
    controlName: string;
    controlValue: string;
    controlDisabled = false;
    boundControl = false;
    customMessage: string;
    options: any;
    selectSubscription: Subscription;
    optionsGetUrl: string;
    validateUrl: string;
    storeId: number;
    memberInfo: any;
    memberId: number;
    enrollCountryCode: string;
    autoCompleteList: string[] = [];
    userInfo: Member;
    isShowLoader = false;
    emailError = false;
    isRetailLogin = false;
    isShowGovernmentIdLoader = false;
    isLegacyUser = false;
    @Input() layoutNode: any;
    @Input() layoutIndex: number[];
    @Input() dataIndex: number[];
    intialPollCount = 0;
    maxPollCount = environment.longPollCount;
    appCountryConfig: AppCountryConfig = null;
    bonusInfoCountryCode: string;

    constructor(
        private jsf: JsonSchemaFormService, private _http: Http,
        private chRef: ChangeDetectorRef,
        private _configurationService: ConfigurationService,
        private _dataService: DataShareService,
        private _commonService: CommonService,
        private _translateService: TranslateService,
        private _translateKey: TranslateKey,
        private _personalMessageService: PersonalMessageService,
        private _appCountryConfigService: AppConfigService
    ) { }

    ngOnInit() {
        this.enrollCountryCode = this._configurationService.getEnrollCountry().toUpperCase();
        this.storeId = this._configurationService.getStoreID();
        this.bonusInfoCountryCode = this._configurationService.getBonusInfoCountry();
        if (this.bonusInfoCountryCode) {
            this.enrollCountryCode = this.bonusInfoCountryCode.toUpperCase();
        }
        this.appCountryConfig = this._appCountryConfigService.getSettings(this.enrollCountryCode, null);
        //set in some common service and get data
        //this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        //this.storeId = this._cacheService.get(CacheKey.StoreConfiguration).id;
        //this.memberInfo = this._cacheService.get(CacheKey.CheckoutInformation);
        this.options = this.layoutNode.options || {};
        if (this.options) {
            this.jsf.initializeControl(this);
            if (this.controlName && this.controlValue) {
                if (this.controlName == SchemaProperty.ACCOUNTNUMBER) {
                    if (this.appCountryConfig && this.appCountryConfig.validateUniqueCheckOnLoad) {
                        this.getService(this.controlValue)
                    }
                } else {
                    this.getService(this.controlValue)
                }          
            }
        }
        this._personalMessageService.getPreviousAccountNumber().subscribe((previousBonusInfo) => {
            if (previousBonusInfo && previousBonusInfo.accountNumber) {
                this.controlValue = previousBonusInfo.accountNumber;
                this.getService(this.controlValue)
            } 
        });

    }

    /**
      * @returns Observable
      */
    validateUnique(optionUrl: string): Observable<any> {
        return this._http
            .get(optionUrl)
            .map((response: any) => response);
    }

    /**
    * @returns void
    */
    getService(validateValue: any): void {
        const previousBonusInfo: BonusInfo = this._personalMessageService.getPreviousBonusInfo();
        const schemaProperty: any = this.jsf.schema.properties[this.controlName];
        
        if ((validateValue.trim()).length > 0 && this.formControl.valid) {
            if (this.controlName === 'governmentId') {
                this.validateUrl = environment.apiUrl + schemaProperty.optionGetUrl + 'storeId=' + this.storeId
                    + '&governmentId=' + validateValue + '&countryCode=' + this.enrollCountryCode;
                this.isShowGovernmentIdLoader = true;
                this._dataService.isGovernmentIdValidating = this.isShowGovernmentIdLoader;
            } else if (this.controlName === SchemaProperty.ACCOUNTNUMBER) {
                if(previousBonusInfo && validateValue === previousBonusInfo.accountNumber){
                    schemaProperty.customErrorMessage = null;
                    schemaProperty.uniqueValidationMessage = null;
                    this.showCustomErrorMessage(schemaProperty);
                    sessionStorage.removeItem('customError-' + this.controlName);
                    this.customMessage = null;
                    this._personalMessageService.setValidBonusInfoForm(true);
                    return;
                }
                this.validateUrl = environment.apiUrl + schemaProperty.optionGetUrl
                 + '&accountNumber=' + validateValue + '&countryCode=' + this.enrollCountryCode;
                this.isShowGovernmentIdLoader = true;
                this._dataService.isGovernmentIdValidating = this.isShowGovernmentIdLoader;
            }
            else if (this.controlName === SchemaProperty.BSNNUMBER) {
                if(previousBonusInfo && validateValue === previousBonusInfo.bsnNumber){
                    schemaProperty.customErrorMessage = null;
                    schemaProperty.uniqueValidationMessage = null;
                    this.showCustomErrorMessage(schemaProperty);
                    sessionStorage.removeItem('customError-' + this.controlName);
                    this.customMessage = null;
                    this._personalMessageService.setValidBonusInfoForm(true);
                    return;
                }
                this.validateUrl = environment.apiUrl + schemaProperty.optionGetUrl
                 + '&bsnNumber=' + validateValue + '&countryCode=' + this.enrollCountryCode;
                this.isShowGovernmentIdLoader = true;
                this._dataService.isGovernmentIdValidating = this.isShowGovernmentIdLoader;
            } else {
                this.intialPollCount = 0;
                let validateUrl: string;
                if (schemaProperty && schemaProperty.optionGetUrl) {
                  validateUrl = environment.apiUrl + schemaProperty.optionGetUrl.slice(0, -1);
                  validateValue = encodeURIComponent(validateValue);
                  this.validateUrl = validateUrl + validateValue;
                }
                if (environment.enableLongPoll && this.controlName === 'email') {
                    this.validateUrl = this.validateUrl + '&isPoll=' + environment.enableLongPoll;
                }
                this.isShowLoader = true;
                this._dataService.isEmailValidating = this.isShowLoader;
            }
            let placeholder: string = schemaProperty.placeholder;
            if (placeholder) {
                placeholder = placeholder.slice(0, -1);
            }
            this.customMessage = '';
            sessionStorage.setItem('validationStatus-' + this.controlName, 'InProgress');
            if(this.validateUrl){
            this.selectSubscription = this.validateUnique(this.validateUrl)
                .subscribe((response) => {
                    if ((response === null || response === undefined) && placeholder === SchemaProperty.EMAIL) {
                        if (!this.chRef['destroyed']) {
                            this.chRef.detectChanges();
                        }
                        this.isShowLoader = false;
                        this.emailError = false;
                        this._dataService.isEmailValidating = this.isShowLoader;
                        sessionStorage.removeItem('validationStatus-' + this.controlName);
                        return;
                    }
                    sessionStorage.removeItem('validationStatus-' + this.controlName);
                    if (this.controlName !== 'email') {
                        this.isShowGovernmentIdLoader = false;
                        this._dataService.isGovernmentIdValidating = this.isShowGovernmentIdLoader;
                    }
                    if (response && response._body === 'false') {
                        schemaProperty.customErrorMessage = '';
                        schemaProperty.uniqueValidationMessage = '';
                        this.showCustomErrorMessage(schemaProperty);
                    } else if (response && response._body === 'true') {
                        this.showCustomErrorMessage(schemaProperty);
                    } else if (response && placeholder === SchemaProperty.EMAIL) {
                        // Store Member data for Guest user
                        if (!this.chRef['destroyed']) {
                            this.chRef.detectChanges();
                        }
                        this.mapUserInfoForOptInMember(response, schemaProperty);
                    } else if (response && response._body && this.controlName == SchemaProperty.ACCOUNTNUMBER) {
                        if ((validateValue.trim()).length > 1) {
                            this.isShowGovernmentIdLoader = false;
                            this._dataService.isGovernmentIdValidating = this.isShowGovernmentIdLoader;
                            let ibanValidationResponse: IbanValidation = JSON.parse(response._body);
                            if (ibanValidationResponse) {
                                if (ibanValidationResponse.valid) {
                                    this._personalMessageService.setValidateIbanInfo(false);
                                    if (ibanValidationResponse.duplicate) {
                                        if (previousBonusInfo && previousBonusInfo.accountNumber && previousBonusInfo.accountNumber == validateValue) {
                                            ibanValidationResponse.duplicate = false;
                                        } else {
                                            schemaProperty.customErrorMessage = ibanValidationResponse.message;
                                            schemaProperty.uniqueValidationMessage = ibanValidationResponse.message;
                                            this.showCustomErrorMessage(schemaProperty);
                                        }
                                    }
                                } else {
                                    schemaProperty.customErrorMessage = ibanValidationResponse.message;
                                    schemaProperty.uniqueValidationMessage = ibanValidationResponse.message;
                                    this.showCustomErrorMessage(schemaProperty);
                                    this._personalMessageService.setValidateIbanInfo(true);
                                }
                                if (!ibanValidationResponse.valid || ibanValidationResponse.duplicate) {
                                    // this.formControl.setErrors({ "pattern": true });
                                    this._personalMessageService.setValidBonusInfoForm(false);
                                } else {
                                    sessionStorage.removeItem('customError-' + this.controlName);
                                    this.customMessage = null;
                                    this._personalMessageService.setValidBonusInfoForm(true);
                                }
                            }
                            if (!this.chRef['destroyed']) {
                                this.chRef.detectChanges();
                            }
                        }else{
                            if((validateValue.trim()).length == 1){
                                schemaProperty.customErrorMessage = 'Invalid IBAN';
                                this.showCustomErrorMessage(schemaProperty);
                            }else{
                                schemaProperty.customErrorMessage = 'Required';
                                this.showCustomErrorMessage(schemaProperty);
                            }

                        }
                    } else if (response) {
                        if(response._body && this.controlName == SchemaProperty.BSNNUMBER){
                            if ((validateValue.trim()).length > 1) {
                                this.isShowGovernmentIdLoader = false;
                                this._dataService.isGovernmentIdValidating = this.isShowGovernmentIdLoader;
                                let bsnValidationResponse =  JSON.parse(response._body);
                                if (bsnValidationResponse.valid) {
                                    if (bsnValidationResponse.duplicate) {
                                        if (previousBonusInfo && previousBonusInfo.bsnNumber && previousBonusInfo.bsnNumber == validateValue) {
                                            bsnValidationResponse.duplicate = false;
                                        } else {
                                            schemaProperty.customErrorMessage = bsnValidationResponse.message;
                                            schemaProperty.uniqueValidationMessage = bsnValidationResponse.message;
                                            this.showCustomErrorMessage(schemaProperty);
                                        }
                                    }
                                } 
                                else{
                                    schemaProperty.customValidationMessage = bsnValidationResponse.message;
                                    schemaProperty.uniqueValidationMessage = bsnValidationResponse.message;
                                    this.showCustomErrorMessage(schemaProperty);
                                }
                                if (!bsnValidationResponse.valid || bsnValidationResponse.duplicate) {
                                    this._personalMessageService.setValidBonusInfoForm(false);
                                } else {
                                    sessionStorage.removeItem('customError-' + this.controlName);
                                    this.customMessage = null;
                                    this._personalMessageService.setValidBonusInfoForm(true);
                                }
                                if (!this.chRef['destroyed']) {
                                    this.chRef.detectChanges();
                                }
                                }else{
                                if((validateValue.trim()).length == 1){
                                    schemaProperty.customErrorMessage = 'Invalid BSN';
                                    this.showCustomErrorMessage(schemaProperty);
                                }else{
                                    schemaProperty.customErrorMessage = 'Required';
                                    this.showCustomErrorMessage(schemaProperty);
                                }
                        }
                        
                    }
                    else{
                        this.showCustomErrorMessage(schemaProperty);
                    }
                }
                }, (errResponse: any) => {
                    this.isShowGovernmentIdLoader = false;
                    if (!this.chRef['destroyed']) {
                        this.chRef.detectChanges();
                    }
                    this.emailError = false;
                    this._dataService.isGovernmentIdValidating = this.isShowGovernmentIdLoader;
                    this._dataService.isEmailValidating = this.isShowLoader;
                    sessionStorage.removeItem('validationStatus-' + this.controlName);
                    if (placeholder === SchemaProperty.EMAIL) {
                        // this._cacheService.remove(CacheKey.OptInMember);
                    }
                    if (errResponse.status === StatusCodes.Conflict) {
                        schemaProperty.customErrorMessage = 'Phone Number Already Exists';
                        schemaProperty.uniqueValidationMessage = 'Phone Number Already Exists';
                        this.showCustomErrorMessage(schemaProperty);
                    } else if (errResponse.status === StatusCodes.NotFound
                        || errResponse.status === StatusCodes.InternalServerError) {
                        this.customMessage = '';
                        sessionStorage.setItem('customError-' + this.controlName, 'true');
                        this.jsf.updateValue(this, validateValue);
                    }
                    const response = errResponse;
                    if (this.controlName === 'governmentId' && response && response.validations
                        && !response.statusCode && response.validations.length > 0) {
                        schemaProperty.uniqueValidationMessage = response.validations[0].message;
                        this.showCustomErrorMessage(schemaProperty);
                    }
                });
            }
        } else {
            if (this.controlName === 'governmentId') {
                this.customMessage = '';
                sessionStorage.removeItem('customError-' + this.controlName);
            }
        }
    }

    /**
     * This method used for set Member response for Guest User
     * validateGuest
     * @param {*} response
     * @param {string} schemaProperty
     * @memberof CustomInputComponent
     */
    mapUserInfoForOptInMember(response: any, schemaProperty: any): void {
        if (response) {
            const memberResponse = response._body ? JSON.parse(response._body) : response;
            this.isRetailLogin = false;
            this.isLegacyUser = false;
            if (this.intialPollCount < this.maxPollCount) {
                this.intialPollCount++;
                if (memberResponse.requestStatus === ResponseStatus.COMPLETED || !memberResponse.requestStatus) {
                    this.isShowLoader = false;
                    this._dataService.isEmailValidating = this.isShowLoader;
                    if (memberResponse && !memberResponse.distributorId && memberResponse.memberId) {
                        let errorTranslatedText = '';
                        if (memberResponse.memberTypeId === MemberType.GUEST) {
                            errorTranslatedText = Translations.GUEST_SIGNUP_INPROGRESS;
                        } else {
                            errorTranslatedText = Translations.ENROLLMENT_INPROGRESS;
                        }
                        let errorTranslatedValue = this._translateService.get('schemaform.' + errorTranslatedText)['value'];
                        errorTranslatedValue = this._translateKey.transform(errorTranslatedValue, false);
                        schemaProperty.customErrorMessage = errorTranslatedValue;
                        schemaProperty.uniqueValidationMessage = errorTranslatedValue;
                        this.showCustomErrorMessage(schemaProperty, true);
                    } else if (memberResponse && (memberResponse.memberTypeId === MemberType.GUEST
                        || (memberResponse.memberTypeId === MemberType.RETAILCUSTOMER && this.userInfo))) {
                        //this._cacheService.set(CacheKey.OptInMember, this.mapAccountResponseToUserInfo(memberResponse));
                        this.emailError = false;
                        if (!this.chRef['destroyed']) {
                            this.chRef.detectChanges();
                        }
                    } else {
                        if (memberResponse && memberResponse.memberTypeId === MemberType.RETAILCUSTOMER) {
                            this.isRetailLogin = true;
                        }
                        if (memberResponse && memberResponse.distributorId && !memberResponse.memberId) {
                            this.isLegacyUser = true;
                        }
                        this.showCustomErrorMessage(schemaProperty);
                    }
                } else if (memberResponse.requestStatus === ResponseStatus.QUEUED ||
                    memberResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                    this._commonService.processPollRequest(memberResponse.location)
                        .subscribe(responseObj => {
                            const inputProperty: any = this.jsf.schema.properties[this.controlName];
                            this.mapUserInfoForOptInMember(responseObj, inputProperty);
                        }, errorResponse => {
                            this.emailError = false;
                            this.isShowLoader = false;
                            this._dataService.isEmailValidating = this.isShowLoader;
                            if (!this.chRef['destroyed']) {
                                this.chRef.detectChanges();
                            }
                        });
                }
            }
        }
    }


    // /**
    // * @description this method is used
    // * to map the validated account response to user info  varible of
    // * personalinfo settings
    // * @date 2018-07-19
    // * @private
    // * @memberof CustomInputComponent
    // */
    // mapAccountResponseToUserInfo(verifyAccountResponse: VerifyAccountResponse): Member {
    //     const userInfo: Member = {
    //         distributorId: verifyAccountResponse.distributorId,
    //         email: verifyAccountResponse.email,
    //         firstName: verifyAccountResponse.firstName,
    //         fullName: verifyAccountResponse.fullName,
    //         homeCountryId: verifyAccountResponse.homeCountryId,
    //         lastName: verifyAccountResponse.lastName,
    //         memberAllowedCountries: verifyAccountResponse.memberAllowedCountries,
    //         memberId: verifyAccountResponse.memberId,
    //         memberTitle: verifyAccountResponse.memberTitle,
    //         memberTitleId: verifyAccountResponse.memberTitleId,
    //         memberType: verifyAccountResponse.memberType,
    //         memberTypeId: verifyAccountResponse.memberTypeId,
    //         middleName: verifyAccountResponse.middleName,
    //         phone: verifyAccountResponse.phone,
    //         profileImageURL: verifyAccountResponse.profileImageURL,
    //         sponsorId: verifyAccountResponse.sponsorId,
    //         userEntityId: verifyAccountResponse.userEntityId,
    //         userId: verifyAccountResponse.userId,
    //         userName: verifyAccountResponse.userName,
    //         userType: verifyAccountResponse.userType,
    //         wholesaleQualified: false,
    //         preferenceValue: verifyAccountResponse.preferenceValue,
    //         displayName: verifyAccountResponse.displayName,
    //         isExternal: verifyAccountResponse.external
    //     };
    //     return userInfo;
    // }

    /**
     * @returns void
     */
    private showCustomErrorMessage(schemaProperty: any, isCustomMsg?: boolean): void {
        if (schemaProperty) {
            if (schemaProperty.placeholder === 'Email*' && schemaProperty.uniqueValidationMessage && !isCustomMsg) {
                this.emailError = true;
                this.isShowLoader = false;
            } else {
                this.emailError = false;
                schemaProperty.customErrorMessage = schemaProperty.uniqueValidationMessage;
                this.customMessage = schemaProperty.uniqueValidationMessage;
            }
            sessionStorage.setItem('customError-' + this.controlName, schemaProperty.uniqueValidationMessage);
        }
        if (!this.chRef['destroyed']) {
            this.chRef.detectChanges();
        }
    }

    /**
     * @returns void
     */
    removeError(): void {
        sessionStorage.removeItem('customError-' + this.controlName);
    }

    /**
     * @returns void
     */
    validationInProgress($event: any): void {
        sessionStorage.setItem('validationStatus-' + this.controlName, 'InProgress');
        if (this.controlName === SchemaProperty.SORTCODE || this.controlName === SchemaProperty.ACCOUNTNUMBER
             && this.options && this.options.dynamicValidation) {
                this.restrictCharacter($event);
        }
    }

    /**
     * @description This method used to allow numbers only
     * @date 2020-09-19
     * @private
     * @memberof CustomInputComponent
     */
    restrictCharacter(event): void {
        if (event.keyCode !== 8) {
            const value: any = (event.key ? event.key : '');
            const pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    }

    /**
     * @param  {any} event
     */
    updateValue(event: any) {
        if (event && event.target && event.target.name === 'governmentId') {
            if (event.target.value && event.target.value.length > 0) {
                // this.isShowGovernmentIdLoader = true;
                event.target.value = event.target.value.replace(/\s/g, '');
            } else if ((event.target.value && event.target.value.length === 0) || !event.target.value) {
                // this.isShowGovernmentIdLoader = false;
            }
            // this._dataService.isGovernmentIdValidating = this.isShowGovernmentIdLoader;
        }
        if (event && event.target && event.target.name === 'email') {
            if (event.target.value && event.target.value.length > 0) {
                // event.target.value = event.target.value.trim();
                event.target.value = event.target.value.replace(/\s/g, '');
            }
        }
        this.jsf.updateValue(this, event.target.value);
    }


    /**
    * @param  {any} event
    */
    validateInputValue(event: any) {
        if (!this.options.readonly && this.options.optionGetUrl) {
            this.getService(event.target.value);
        }
    }


    /**
    * @description set uppercase while on changing GovernmentID
    * @date 2021-03-17
    * @memberof CustomMaskTextboxComponent
    */
    onChange() {
        if (this.controlValue && this.layoutNode.name === 'governmentId') {
            this.controlValue = this.controlValue.toUpperCase();
        } if (this.controlValue && this.layoutNode.name === 'accountNumber') {
            this.controlValue = this.controlValue.replace(/\s/g, "");
        }
    }


    focusInputOnChange(): void {
        if ((this.controlName === SchemaProperty.SORTCODE || this.controlName === SchemaProperty.ACCOUNTNAME
            || this.controlName === SchemaProperty.ACCOUNTNUMBER) && this.options && this.options.dynamicValidation
            && this.controlValue && this.controlValue.length === 1) {
            setTimeout(() => {
                const ele = document.getElementsByName(this.controlName);
                if (ele && ele[0]) {
                    ele[0].focus();
                }
            }, 0);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/widgets/custom-textbox.widget.ts